<template>
  <div>
      <b-card no-body class="custom-card-bg">
        <template #header>
          <div class="d-flex justify-content-between align-items-center w-100">
            <span class="m-0 font-weight-bold mx-auto">Tip Jar</span>
            <b-button pill size="sm" variant="light" class="view-history-btn" @click="onTipViewChanged" :title="getActionButtonTitle">
              <MdClockIcon w="14px" h="14px" class="mr-1" /> {{ getActionButtonTitle }}
            </b-button>
          </div>
        </template>
        <b-card-body>
          <div v-if="!resource.tips_enabled">
            Tips are disabled for this livestream
          </div>
          <div v-if="tips.length > 0" class="d-flex flex-row tips-container">

            <div v-for="[index, eachTip] of tipsToView.entries()" :key="index" class="mx-1">
              <!-- {{ eachTip }} -->
              <b-badge style="cursor: pointer;" @click="showTipDetails(eachTip)">
                {{ eachTip.username }}
                <MdTrashIcon class="tip-delete" w="18px" h="18px" v-if="!eachTip.expired" @click.native="deleteTip(index)" />
              </b-badge>
            </div>

          </div>
        </b-card-body>

      </b-card>

      <div v-if="showTipModal" class="tip-details-inline mt-1" :style="`border-left: 3px solid ${getColorCode(selectedTip)};`">
        <div class="d-flex justify-content-between align-items-start">
          <div class="tip-info">
           <span class="">{{selectedTip.username}}</span>
           <span class=""> has tipped </span>
           <span class="tip-value">${{selectedTip.meta.value}}</span>
          </div>
          <button class="btn-close-inline" @click="showTipModal = false;selectedTip = null;">&times;</button>
        </div>
        <div v-if="selectedTip.text !==''" class="tip-message-inline">
          <span class="tip-label">Message: </span>
          <span class="message-text">{{ selectedTip.text }}</span>
        </div>
        <div class="mt-2 time-font"> <span>{{selectedTip.expired ? 'Expired at:' : 'Expires at:'}}</span> {{getExpiredAt(selectedTip.expires_at)}}</div>
      </div>
  </div>
</template>

<script>
import MdTrashIcon from 'vue-ionicons/dist/md-trash.vue'
import MdClockIcon from 'vue-ionicons/dist/md-clock.vue'

export default {
  name: 'TipManager',
  props: {
    resource: {
      type: Object,
      required: true
    },
    tips: {
      type: Array,
      required: true,
      default: () => []
    },
    tipMeta: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  components: {
    MdTrashIcon,
    MdClockIcon
  },
  data () {
    return {
      showTipModal: false,
      selectedTip: null,
      // tips: [],
      tipsToView: [],
      showExpiredTips: false
    }
  },
  mounted () {
    // this.tips = this.pastTips
    this.setTipsToView()
  },
  computed: {
    getActionButtonTitle () {
      return this.showExpiredTips ? 'Show Active Tips' : 'Show Expired Tips'
    }
  },
  methods: {
    getColorCode (tip) {
      const tipAttribute = this.tipMeta[tip.tip_id]
      return tipAttribute.color
    },
    onTipViewChanged () {
      this.showExpiredTips = !this.showExpiredTips
      this.setTipsToView()
    },
    setTipsToView () {
      if (this.showExpiredTips) {
        this.tipsToView = this.tips.filter(tip => tip.expired)
      } else {
        this.tipsToView = this.tips.filter(tip => !tip.expired)
      }
    },
    showTipDetails (tip) {
      this.selectedTip = tip
      this.selectedTip.meta = this.tipMeta[tip.tip_id]
      this.showTipModal = true
    },
    getExpiredAt (timetoken) {
      const date = new Date(timetoken)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    },
    deleteTip (tipIndex) {
      const tipDeleteConfirm = confirm('Are you sure you want to delete this tip?')
      if (!tipDeleteConfirm) {
        return
      }
      this.$emit('deleteTip', tipIndex)
    }
  }
}
</script>

<style scoped>
.custom-card-bg .card-header{
  background-color: #182028;
  color: #fff;
  border-bottom: 0;
  padding: 10px 15px;
}

.tips-container {
  overflow-x: auto;
  white-space: nowrap;
  padding-bottom: 5px; /* for scrollbar spacing */
}

.tips-container > div {
  flex: 0 0 auto;
}

.view-history-btn {
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  color: #182028;
  background-color: #f1f3f4;
  border-color: #f1f3f4;
  padding: 4px 12px;
}

.view-history-btn:hover {
  background-color: #e2e6ea;
  border-color: #dae0e5;
}

.tip-delete{
  cursor: pointer;
  margin-left: 8px;
}

.tip-details-inline {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 0.85em;
  border-left: 3px solid #ef2324;
}

.tip-info {
  font-weight: 600;
}

.tip-value {
  color: #85BB65;
}

.btn-close-inline {
  background: transparent;
  border: none;
  color: #999;
  font-size: 1.25em;
  line-height: 1;
  padding: 0 5px;
  cursor: pointer;
  transition: color 0.2s;
}

.btn-close-inline:hover {
  color: #000000;
}

.tip-message-inline {
  margin-top: 4px;
  word-break: break-word;
}

.message-text {
  color: #959494;
  font-style: italic;
}
</style>
